import { dateProvider } from '@utils';
import { TFunction } from 'i18next';

export const getInternalNotesDateString = (d: Date, t: TFunction<'ChatTranslations'>) => {
  const now = dateProvider.now();
  const diffInMinutes = dateProvider.diff(d, now, 'minutes');
  const diffInHours = dateProvider.diff(d, now, 'hours');

  if (diffInMinutes < 1) return t('NOW');

  if (diffInMinutes < 60) return t('MINUTES_AGO', { count: diffInMinutes });

  if (diffInHours < 24) return t('HOURS_AGO', { count: diffInHours });

  return dateProvider.format(d, 'dd MMM yyyy, HH:mm');
};
